import { render, staticRenderFns } from "./AppInfoCard.vue?vue&type=template&id=6481b8d9&scoped=true"
import script from "./AppInfoCard.vue?vue&type=script&lang=js"
export * from "./AppInfoCard.vue?vue&type=script&lang=js"
import style0 from "./AppInfoCard.vue?vue&type=style&index=0&id=6481b8d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6481b8d9",
  null
  
)

export default component.exports